import { useMemo } from 'react'

import type {
  FlightPlayerScoresFragment,
  HoleScoreFragment,
} from '../../../__generated__/hooks'
import type { CurrentPlayerCtx } from '../../../PlayerShell'
import { isNetStrokes } from '../../../util/event-mode'
import Legend from '../components/Legend'
import Table from '../components/Table'

/**
 * Flat scorecard view — one column per flight entry. Handles Golf,
 * POLF, AND Scramble (in Scramble the entries returned by the API are
 * teams; the Table's eyebrow logic resolves to "Ditt lag" automatically
 * for the captain's team column).
 */
const IndividualView = ({
  player,
  flight,
  holes,
}: {
  player: CurrentPlayerCtx
  flight: FlightPlayerScoresFragment[]
  holes: HoleScoreFragment[]
}) => {
  // Sort so the player (or their team in Scramble) sits in column 1.
  const sortedFlight = useMemo(
    () =>
      [...flight].sort((a, b) => {
        const yours = (id: string) => id === player.id || id === player.team?.id
        if (yours(a.id)) return -1
        if (yours(b.id)) return 1
        return 0
      }),
    [flight, player.id, player.team?.id]
  )

  // Stableford ranking (and POLF, whose ranking is never net) → surface the
  // per-hole stableford points on the card. Hidden under net-strokes.
  const showStableford = !isNetStrokes(player.polfEvent.ranking)

  return (
    <section className="pb-6">
      <div className="px-4 pt-4 pb-2 flex items-end justify-between">
        <h1 className="font-display text-xl font-bold text-green-900">
          Scorekort
        </h1>
        <p className="text-xs text-ink-500 num">
          {holes.length} hull · {sortedFlight.length} spillere
        </p>
      </div>
      <Table
        player={player}
        flight={sortedFlight}
        holes={holes}
        showStableford={showStableford}
      />
      <Legend />
    </section>
  )
}

export default IndividualView
